/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free QR code generator. Turn any text, URL, phone number or message into a QR code and download it as a PNG — no sign-up, generated in your browser.`)
};

const es_qr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de códigos QR gratuito. Convierte cualquier texto, URL, número de teléfono o mensaje en un código QR y descárgalo como PNG — sin registro, generado en tu navegador.`)
};

const de_qr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser QR-Code-Generator. Wandle beliebigen Text, eine URL, Telefonnummer oder Nachricht in einen QR-Code um und lade ihn als PNG herunter — ohne Anmeldung, direkt in deinem Browser erstellt.`)
};

const nl_qr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis QR-code generator. Zet tekst, een URL, telefoonnummer of bericht om in een QR-code en download deze als PNG — geen aanmelding nodig, gegenereerd in je browser.`)
};

const fr_qr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de QR code gratuit. Transformez n'importe quel texte, URL, numéro de téléphone ou message en QR code et téléchargez-le en PNG — sans inscription, généré dans votre navigateur.`)
};

const it_qr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di codici QR gratuito. Trasforma qualsiasi testo, URL, numero di telefono o messaggio in un codice QR e scaricalo come PNG — nessuna registrazione, generato nel tuo browser.`)
};

const pt_br2_qr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de código QR gratuito. Transforme qualquer texto, URL, número de telefone ou mensagem em um código QR e baixe como PNG — sem cadastro, gerado no seu navegador.`)
};

const pt_qr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de códigos QR gratuito. Transforme qualquer texto, URL, número de telefone ou mensagem num código QR e descarregue-o em PNG — sem registo, gerado no seu navegador.`)
};

const ja_qr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のQRコード生成ツール。テキスト、URL、電話番号、メッセージなどをQRコードに変換し、PNGとしてダウンロードできます — 登録不要、ブラウザ内で生成。`)
};

const zh_qr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费二维码生成器。将任意文本、链接、电话号码或消息转换为二维码，并下载为 PNG——无需注册，在浏览器中直接生成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_meta_description", locale)
	if (locale === "en") return en_qr_meta_description(inputs)
	if (locale === "es") return es_qr_meta_description(inputs)
	if (locale === "de") return de_qr_meta_description(inputs)
	if (locale === "nl") return nl_qr_meta_description(inputs)
	if (locale === "fr") return fr_qr_meta_description(inputs)
	if (locale === "it") return it_qr_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_qr_meta_description(inputs)
	if (locale === "pt") return pt_qr_meta_description(inputs)
	if (locale === "ja") return ja_qr_meta_description(inputs)
	return zh_qr_meta_description(inputs)
};